import { render } from "./ProfileHeader.vue?vue&type=template&id=71b5fe2a&scoped=true"
import script from "./ProfileHeader.vue?vue&type=script&lang=js"
export * from "./ProfileHeader.vue?vue&type=script&lang=js"

import "./ProfileHeader.vue?vue&type=style&index=0&id=71b5fe2a&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\projetos\\mestre\\mestre-do-valor-sn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b5fe2a"]])

export default __exports__